import { ApiApplicableRateCardDetails } from "../../types/ApiApplicableRateCardDetails";
import sortBy from "lodash/sortBy";
import { getFormattedCurrency, getResolvedString } from "../../utils";
import FieldOption from "../../form/renderer/types/FieldOption";
import ApiRateCardForDisplay from "shared/types/ApiRateCardForDisplay";

interface BulkQuantityOptionsArgsType {
  applicableRates: Array<ApiApplicableRateCardDetails>;
  perTicketPriceStr: string;
}

export function getOptionsForBulkQuantity(props: BulkQuantityOptionsArgsType): Array<FieldOption> {
  const sortedRates = sortBy(props.applicableRates, "lowerLimit");

  return sortedRates.reduce((acc: Array<any>, applicableRate) => {
    const ratesArray = Array.from(
      {
        length: applicableRate.upperLimit - applicableRate.lowerLimit + 1 // Adding +1, because for limit 2-5 we want array of 4 item i.e: [2,3,4,5]
      },
      (_, index) => {
        return {
          id: applicableRate.lowerLimit + index,
          value: getResolvedString(props.perTicketPriceStr, {
            0: applicableRate.lowerLimit + index,
            1: getFormattedCurrency(applicableRate.applicablePrice)
          }),
          displayOrder: applicableRate.lowerLimit + index,
          customData: applicableRate.applicablePrice
        };
      }
    );
    return [...acc, ...ratesArray];
  }, []);
}

export function getOptionsForBulkQuantityFromQuantityBreaks(props: {
  perTicketPriceStr: string;
  quantityBreaks: ApiRateCardForDisplay["quantityBreaks"];
}): Array<FieldOption> {
  const sortedRates = sortBy(props.quantityBreaks, "lowerLimit");

  return sortedRates.reduce((acc: Array<any>, quantityBreak) => {
    const ratesArray = Array.from(
      {
        length: quantityBreak.upperLimit - quantityBreak.lowerLimit + 1 // Adding +1, because for limit 2-5 we want array of 4 item i.e: [2,3,4,5]
      },
      (_, index) => {
        return {
          id: quantityBreak.lowerLimit + index,
          value: getResolvedString(props.perTicketPriceStr, {
            0: quantityBreak.lowerLimit + index,
            1: quantityBreak.currentApplicablePrice && getFormattedCurrency(quantityBreak.currentApplicablePrice)
          }),
          displayOrder: quantityBreak.lowerLimit + index,
          customData: quantityBreak.currentApplicablePrice
        };
      }
    );
    return [...acc, ...ratesArray];
  }, []);
}
